import appliancesAndElectronics from "./img/appliances_and_electronics.png";
import auto from "./img/auto.png";
import bank from "./img/bank.png";
import books from "./img/books.png";
import clothesAndShoes from "./img/clothes_and_shoes.png";
import constructionAndRepair from "./img/construction_and_repair.png";
import finance from "./img/finance.png";
import food from "./img/food.png";
import healthAndMedicine from "./img/health_and_medicine.png";
import home from "./img/home.png";
import marketplaces from "./img/marketplaces.png";
import massMediaAndNews from "./img/mass_media_and_news.png";
import moviesAndTv from "./img/movies_and_tv.png";
import music from "./img/music.png";
import onlineServices from "./img/online_services.png";
import petSupplies from "./img/pet_supplies.png";
import sports from "./img/sports.png";
import strahovanie from "./img/strahovanie.png";
import supermarket from "./img/supermarket.png";
import travel from "./img/travel.png";

const CATEGORY_GROUPS = {
    internet_services: { title: "Интернет-сервисы", image: onlineServices },
    "eda-": { title: "Еда", image: food },
    "pokupki-i-riteyl-supermarkety-produkty-dostavki-produktov": { title: "Супермаркеты", image: supermarket },
    "zdorove-": { title: "Здоровье и медицина", image: healthAndMedicine },
    "banki-": { title: "Банки", image: bank },
    "podpiski-i-ekosistemy-kinoteatry": { title: "Кино и ТВ", image: moviesAndTv },
    "podpiski-i-ekosistemy-knigi": { title: "Книги", image: books },
    "podpiski-i-ekosistemy-muzyka": { title: "Музыка", image: music },
    "pokupki-i-riteyl-bytovaya-tehnika-i-elektronika": { title: "Быт. техника\nи электроника", image: appliancesAndElectronics },
    "pokupki-i-riteyl-tovary-dlya-doma": { title: "Товары для дома", image: home },
    "pokupki-i-riteyl-stroitelstvo-i-remont": { title: "Строительство и ремонт", image: constructionAndRepair },
    marketplaces: { title: "Маркетплейсы", image: marketplaces },
    "pokupki-i-riteyl-odezhda-i-obuv": { title: "Одежда и обувь", image: clothesAndShoes },
    "pokupki-i-riteyl-zootovary": { title: "Зоотовары", image: petSupplies },
    "transport-": { title: "Транспорт", image: auto },
    insurance: { title: "Страхование", image: strahovanie },
    "puteshestviya-": { title: "Путешествия", image: travel },
    "pokupki-i-riteyl-tovary-dlya-sporta": { title: "Спорт", image: sports },
    mass_media_and_news: { title: "СМИ и новости", image: massMediaAndNews },
    loans_and_microfinance: { title: "Финансы", image: finance },
};

export const categoryImages = Object.fromEntries(Object.entries(CATEGORY_GROUPS).map(([alias, group]) => [alias, group.image]));

export const getCategoryGroupAlias = (alias) => {
    if (typeof alias !== "string") return null;
    if (Object.hasOwn(CATEGORY_GROUPS, alias)) return alias;

    return Object.keys(CATEGORY_GROUPS).find((key) => key.endsWith("-") && alias.startsWith(key)) ?? null;
};

export const getCategoryGroups = (categories, offersByCategory) => {
    const groups = new Set();

    categories.forEach((category) => {
        const alias = getCategoryGroupAlias(category.alias);

        if (alias && offersByCategory.get(category.alias)?.length) groups.add(alias);
    });

    return Object.entries(CATEGORY_GROUPS)
        .filter(([alias]) => groups.has(alias))
        .map(([alias, group]) => ({ alias, title: group.title }));
};

export const getCategoryGroupOffers = (alias, offersByCategory) => {
    if (!Object.hasOwn(categoryImages, alias)) return [];

    return (offersByCategory.get("all")?.offers ?? []).filter((offer) => (offer.categories || offer.vendorcategories || []).some((category) => getCategoryGroupAlias(category.alias) === alias));
};

export const getCategoryTitle = (category) => CATEGORY_GROUPS[category.alias]?.title ?? category.title;

export const sortByTitle = (categories) => [...categories].sort((a, b) => getCategoryTitle(a).localeCompare(getCategoryTitle(b), "ru"));
